<template>
  <div>
    <div class="d-flex justify-content-between">
      <h3 class="page-header">
        {{ $t('productWarrantyExpired.productWarrantyExpired') }}
      </h3>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('productWarrantyExpired.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <div class="row">
      <div class="col-md-3">
        <div class="form-group">
          <ts-card>
            <ts-card-wrapper>
              <ts-loading-banner :loading="loading">
                <form action="">
                  <fieldset>
                    <legend>{{ $t('productWarrantyExpired.criteria') }}</legend>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label class="form-label col-label">{{
                            $t('productWarrantyExpired.branchName')
                          }}</label>
                          <a-select
                            v-model="model.branch_id"
                            mode="multiple"
                            :options="branches"
                            class="ts-w-full"
                            :placeholder="$t('all')"
                            showSearch
                            :filterOption="
                              (input, option) =>
                                option.componentOptions.children[0].text
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                            "
                            @change="onChangeBranch"
                          ></a-select>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label for="label" class="form-laabel col-label">{{
                            $t('productWarrantyExpired.warehouse')
                          }}</label>
                          <a-select
                            v-model="model.location_id"
                            mode="multiple"
                            :defaultActiveFirstOption="true"
                            showSearch
                            :placeholder="$t('all')"
                            :filterOption="
                              (input, option) =>
                                option.componentOptions.children[0].text
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                            "
                            :options="locations"
                            class="ts-w-full"
                          ></a-select>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <ts-checkbox v-model="model.serial_detail">
                            {{ $t('productWarrantyExpired.serialDetail') }}
                          </ts-checkbox>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6 text-right">
                        <ts-button
                          class="btn-block"
                          outline
                          color="success"
                          @click.prevent="exportExcel"
                          :waiting="exporting"
                          ><i class="fas fa-file-excel"></i>
                          {{ $t('excel') }}</ts-button
                        >
                      </div>
                      <div class="col-md-6 text-right">
                        <ts-button
                          class="btn-block"
                          color="primary"
                          @click.prevent="preview"
                          :waiting="waiting"
                          ><i class="fas fa-file-pdf"></i>
                          {{ $t('preview') }}</ts-button
                        >
                      </div>
                    </div>
                  </fieldset>
                </form>
              </ts-loading-banner>
            </ts-card-wrapper>
          </ts-card>
        </div>
      </div>
      <div class="col-md-9">
        <ts-card>
          <ts-card-wrapper>
            <form>
              <fieldset>
                <legend>{{ $t('productWarrantyExpired.preview') }}</legend>
                <ts-preview-pdf v-model="waiting" :src="src"></ts-preview-pdf>
              </fieldset>
            </form>
          </ts-card-wrapper>
        </ts-card>
      </div>
    </div>
  </div>
</template>
<script>
import { Errors } from 'form-backend-validation'
import { mapActions } from 'vuex'
import * as FileDownload from 'downloadjs'
import { trim } from 'lodash'

export default {
  name: 'productWarrantyExpired',
  data() {
    return {
      loading: false,
      waiting: false,
      exporting: false,
      branches: [],
      locations: [],
      src: '',
      model: {
        branch_id: [],
        location_id: [],
        serial_detail: false
      }
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    ...mapActions('report/resource', ['getBranch', 'getLocation']),
    async fetchData() {
      this.loading = true
      await this.getBranch()
        .then(response => {
          this.branches = response.data.map(el => ({
            value: el.branch_id,
            label: el.branch_name_en
          }))
          this.model.branch_id = [
            this.$store.state.authUser.user.default_branch.branch_id
          ]
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
          this.onChangeBranch()
        })
    },
    onChangeBranch() {
      this.locationLoading = true
      this.locations = []
      this.model.location_id = undefined
      this.$store
        .dispatch('report/resource/getLocation', {
          branch_id: this.model.branch_id
        })
        .then(response => {
          this.locations = response.data.map(el => ({
            value: el.location_id,
            label: el.location_name_en
          }))
        })
        .finally(() => {
          this.locationLoading = false
        })
    },
    preview() {
      this.error = new Errors()
      this.waiting = true
      this.src = ''
      this.$store
        .dispatch('report/inventory/productWarrantyExpired', this.model)
        .then(response => {
          console.log(response)
          this.src = response.url
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.error = new Errors(error.Errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    exportExcel() {
      this.exporting = true
      this.errors = new Errors()

      this.$store
        .dispatch('report/inventory/productWarrantyExpiredExcel', this.model)
        .then(response => {
          let filename = trim(
            response.headers['content-disposition']
              .substring(
                response.headers['content-disposition'].indexOf('filename')
              )
              .replace('filename=', ''),
            '"'
          )
          FileDownload(response.data, filename)
        })
        .catch(err => {
          let error = JSON.parse(
            String.fromCharCode.apply(null, new Uint8Array(err))
          )
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => (this.exporting = false))
    }
  }
}
</script>
